import React from 'react';

// BetaTalk podcast episode featuring Rebel Heat's founder.
const PODCAST_URL =
  'https://betatalk.buzzsprout.com/509671/episodes/18685487-archaeological-engineering-james-twallin-on-gas-leaks-and-church-heat-pumps';

const PodcastFeature = () => {
  return (
    <section id="podcast" className="section-padding">
      <div className="container-max px-4">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <p className="text-xs font-bold tracking-widest text-rebel-coral uppercase mb-4 font-sans" style={{ maxWidth: 'none' }}>
            AS FEATURED ON
          </p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-semibold mb-6 text-rebel-dark leading-tight">
            Featured on the BetaTalk podcast
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 leading-relaxed w-full" style={{ maxWidth: 'none' }}>
            Our founder joined Nathan Gambling to talk gas leaks, church heat pumps, and the data behind clean heat.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="game-card p-10 sm:p-12 text-center">
            {/* Quote */}
            <blockquote className="mb-8">
              <p className="text-3xl sm:text-4xl font-bold text-rebel-dark leading-tight">
                <span className="text-rebel-coral">&ldquo;</span>A lovely little device<span className="text-rebel-coral">&rdquo;</span>
              </p>
            </blockquote>

            {/* Attribution */}
            <div className="mb-10">
              <p className="text-lg font-bold text-rebel-dark">Nathan Gambling</p>
              <p className="text-base text-gray-600">
                Podcast host &amp; founder of The Guild of Master Heat Engineers
              </p>
            </div>

            {/* Episode CTA */}
            <a
              href={PODCAST_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-rebel-coral text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-rebel-orange transition-all duration-200 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-rebel-coral min-h-[44px] touch-manipulation shadow-lg"
              aria-label="Listen to the BetaTalk podcast episode featuring Rebel Heat"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path d="M10 3.5a1.5 1.5 0 013 0V11a1.5 1.5 0 01-3 0V3.5z" />
                <path d="M5 8a1 1 0 011 1v2a4 4 0 008 0V9a1 1 0 112 0v2a6 6 0 01-5 5.917V19a1 1 0 11-2 0v-2.083A6 6 0 014 11V9a1 1 0 011-1z" />
              </svg>
              Listen to the episode
            </a>

            <p className="text-sm text-gray-500 mt-6 italic">
              &ldquo;Archaeological Engineering &mdash; James Twallin on Gas Leaks and Church Heat Pumps&rdquo;
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PodcastFeature;
